<div class="header-row">
  <div class="info-text">
    <nb-icon pack="eva" icon="alert-circle-outline"></nb-icon>
    <span>Ansprechpartner des Gebäudes — E-Mail und Telefonnummer sind optional.</span>
  </div>
  <div class="header-actions">
    <button nbButton status="primary" [disabled]="disabledSignal()" (click)="addContact()" nbTooltip="Kontakt hinzufügen">
      <nb-icon pack="eva" icon="plus-outline"></nb-icon>
    </button>
  </div>
</div>

@let array = formArray();
@if (array) {
  <div [formGroup]="$any(array)" class="contact-edit-list">
    @for (group of controls(); track group; let i = $index) {
      <div [formGroupName]="i" class="contact-item-wrapper">
        <div class="contact-item">
          <div class="contact-fields">
            <div class="contact-field">
              <label class="label" [for]="'contact-name-' + i">Name</label>
              <input fullWidth [id]="'contact-name-' + i" type="text" nbInput formControlName="name" placeholder="Name">
              @if (hasError(i, 'name')) { <small class="text-danger">Pflichtfeld</small> }
            </div>
            <div class="contact-field">
              <label class="label" [for]="'contact-phone-' + i">Telefon</label>
              <nb-form-field>
                <input fullWidth [id]="'contact-phone-' + i" type="tel" nbInput formControlName="phone" placeholder="Telefon">
                @if (disabledSignal() && group.get('phone')?.value; as phone) {
                  <button nbSuffix nbButton ghost status="primary" type="button"
                          nbTooltip="Telefonnummer kopieren"
                          (click)="copyToClipboard(phone, 'Telefonnummer')">
                    <nb-icon pack="eva" icon="copy-outline"></nb-icon>
                  </button>
                }
              </nb-form-field>
            </div>
            <div class="contact-field">
              <label class="label" [for]="'contact-email-' + i">E-Mail</label>
              <nb-form-field>
                <input fullWidth [id]="'contact-email-' + i" type="email" nbInput formControlName="email" placeholder="E-Mail">
                @if (disabledSignal() && group.get('email')?.value; as email) {
                  <button nbSuffix nbButton ghost status="primary" type="button"
                          nbTooltip="E-Mail-Adresse kopieren"
                          (click)="copyToClipboard(email, 'E-Mail-Adresse')">
                    <nb-icon pack="eva" icon="copy-outline"></nb-icon>
                  </button>
                }
              </nb-form-field>
              @if (hasError(i, 'email')) { <small class="text-danger">Ungültige E-Mail-Adresse</small> }
            </div>
          </div>
        </div>
        @if (!disabledSignal()) {
          <div class="item-actions">
            <button nbButton ghost status="danger" type="button"
                    (click)="removeContact(i)" nbTooltip="Entfernen">
              <nb-icon pack="eva" icon="trash-2-outline"></nb-icon>
            </button>
          </div>
        }
      </div>
    }
  </div>

  @if (disabledSignal() && !controls().length) {
    <span class="empty">— keine Kontakte hinterlegt —</span>
  }
}
